import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { paramCheckErrno } from '../utils';
export interface setCapsuleShowOption extends Partial<GeneralInvokeOption> {
  isShow: Boolean;
  invalidParamObj?: '';
}

// 设置小程序胶囊显隐
export function setCapsuleShow(option: setCapsuleShowOption) {
  if (
    paramCheckErrno(APINames.Native.SET_CAPSULE_SHOW, option, { isShow: false })
  ) {
    const finalOption = Object.assign(
      {
        isShow: true
      },
      option
    );
    return MacleJSBridge.beforeInvoke(
      APINames.Native.SET_CAPSULE_SHOW,
      finalOption
    );
  }
  return option.invalidParamObj;
}
